import React from "react";

export default function ChoirEvents() {
  // Placeholder event data
  const events = [
    {
      title: "Jos City Choral Festival",
      date: "Sat, July 20, 2025",
      location: "St. Gregory's Cathedral, Jos",
      description: "A city-wide festival for choirs to perform, network, and learn from top directors. Free masterclasses and showcase concert.",
    },
    {
      title: "Virtual Hymn Sing-Along",
      date: "Sun, August 10, 2025",
      location: "Online (Zoom & YouTube Live)",
      description: "Join choristers worldwide for a fun, inspiring virtual sing-along of classic hymns. All ages and skill levels welcome.",
    },
    {
      title: "Workshop: Singing in Harmony",
      date: "Fri, Sept 5, 2025",
      location: "All Saints Hall, Rayfield",
      description: "A hands-on workshop for beginners and advanced singers, focusing on blending, pitch, and part-singing. Certificate awarded.",
    },
  ];

  return (
    <div className="min-h-[70vh] bg-gradient-to-tr from-green-50 via-lime-50 to-white py-10 px-2">
      {/* Hero section */}
      <div className="max-w-3xl mx-auto text-center mb-12">
        <div className="flex flex-col items-center justify-center">
          <span className="rounded-full bg-green-100 p-4 mb-3 shadow">
            <svg className="w-10 h-10 text-green-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" d="M8 11V5a1 1 0 011-1h6a1 1 0 011 1v6M7 21h10M7 17h10M4 21h16a2 2 0 002-2V7a2 2 0 00-2-2H4a2 2 0 00-2 2v12a2 2 0 002 2z"/>
            </svg>
          </span>
          <h1 className="text-3xl sm:text-4xl font-extrabold text-green-800 mb-2">Upcoming Choir Events</h1>
          <p className="text-lg text-green-700 max-w-xl mx-auto mb-1">
            From workshops and festivals to virtual meetups, find exciting choir happenings near you.
          </p>
          <div className="text-green-600 text-sm font-medium">Stay tuned for updates and registration links!</div>
        </div>
      </div>

      {/* Event cards */}
      <div className="max-w-5xl mx-auto grid gap-7 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
        {events.map((event, idx) => (
          <div key={idx} className="relative rounded-2xl bg-white shadow-xl border border-green-100 p-6 flex flex-col items-start group transition hover:shadow-2xl hover:-translate-y-1">
            {/* Calendar badge */}
            <div className="absolute -top-4 left-5 bg-green-700 text-white rounded-xl px-4 py-1 text-xs font-bold shadow group-hover:bg-lime-600 transition">
              {event.date}
            </div>
            {/* Title */}
            <h2 className="text-lg font-extrabold mb-2 text-green-900">{event.title}</h2>
            <div className="flex items-center mb-1 text-green-600 text-sm">
              <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 12.414a4 4 0 10-1.414 1.414l4.243 4.243a1 1 0 001.414-1.414z" />
              </svg>
              {event.location}
            </div>
            <p className="text-gray-700 mb-3 text-[15px]">{event.description}</p>
            {/* Placeholder button */}
            <button
              className="mt-auto px-5 py-2 bg-gradient-to-r from-green-700 to-lime-500 text-white font-bold rounded-xl shadow hover:from-green-800 hover:to-lime-600 transition text-sm"
              disabled
              title="Coming Soon"
            >
              Registration Opens Soon
            </button>
          </div>
        ))}
      </div>

      {/* Call to action */}
      <div className="max-w-3xl mx-auto mt-14 text-center">
        <div className="inline-block bg-lime-100 px-6 py-4 rounded-2xl border border-lime-200 shadow">
          <div className="text-green-900 font-bold text-lg mb-1">Do you have a choir event to feature?</div>
          <div className="text-green-700 text-sm mb-2">Submit your event and let us spread the word to Nigeria's choir community!</div>
          <button className="bg-gradient-to-r from-green-700 to-lime-500 text-white font-bold px-6 py-2 rounded-xl hover:from-green-800 hover:to-lime-600 shadow transition" disabled>
            Submit Event (Coming Soon)
          </button>
        </div>
      </div>
    </div>
  );
}
